// ** Icon Imports
import { Icon } from '@iconify/react'

const IconifyIcon = ({ icon, ...rest }) => {
  return <Icon icon={icon} fontSize='1.2rem' {...rest} />
}

export default IconifyIcon
